import {html} from "../../admin/script/libs/lit.dist.js";
import {WebElement} from "../../admin/script/custom-elements/abstract-element.js";

class PkStarRating extends WebElement {

    static get properties() {
        return {
            value: {type: Number},
            max: {type: Number},
        };
    }

    constructor() {
        super();
        this.value = 0;
        this.max = 5;
    }

    onClickStar(starId, e) {
        this.value = starId;
        this.dispatchEvent(new CustomEvent('pk:star:rating:change', {
            detail: starId,
        }));
    }

    render() {
        const stars = [];
        let iconClass;
        for (let i = 1; i <= this.max; i++) {
            if (this.value >= (i - 0.5) && this.value < i) {
                iconClass = 'star-half';
            } else if (i <= this.value) {
                iconClass = 'star-fill';
            } else {
                iconClass = 'star';
            }
            stars.push(html`<i class="star bi bi-${iconClass} cursor-pointer" data-score="${i}" @click="${e => this.onClickStar(i, e)}"></i>`);
        }
        return stars;
    }
}

window.customElements.define('pk-star-rating', PkStarRating);
